import React, { useMemo } from 'react'
import SEO from '@/components/Seo'
import RankingSelector from '@/components/Ranking/RankingSelector'
import General from '@/components/Ranking/GeneralRankings/General'
import GeneralTabla from '@/components/Ranking/GeneralRankings/GeneralTabla'
import Sidebar from '@/components/Ranking/Sidebar'

const IndexPage = ({ pageContext }) => {
  const { data, ranking, allRankings, activeRanking, allData } = pageContext
  console.log('pageContext:', pageContext)
  const { asterisco, pretitle, slug, title } = data

  const tablaPosColumns = useMemo(
    () => [
      {
        Header: "RK '20",
        accessor: 'ranking2020',
        width: '10',
        sticky: 'left',
      },
      { Header: 'Universidad', accessor: 'universidad' },
      { Header: 'Índice global 2020', accessor: 'indiceglobal2020' },
      { Header: 'Ranking 2019', accessor: 'ranking2019' },
      { Header: 'Índice global 2019', accessor: 'indiceglobal19' },
      {
        Header: 'Percepción de Calidad (40%)',
        accessor: 'percepciondecalidad',
      },
      { Header: 'Gestión (15%)', accessor: 'gestion' },
      { Header: 'Académicos (15%)', accessor: 'academicos' },
      { Header: 'Alumnos (15%)', accessor: 'alumnos' },
      { Header: 'Investigación (15%)', accessor: 'investigacion' },
    ],
    [],
  )

  const calidadColumns = useMemo(
    () => [
      {
        Header: "RK '20",
        accessor: 'ranking2020',
        width: '10',
        sticky: 'left',
      },
      { Header: 'Universidad', accessor: 'universidad' },
      { Header: 'Índice ponderado', accessor: 'ponderado' },
      { Header: 'Ranking 2019', accessor: 'ranking2019' },
    ],
    [],
  )

  const gestionColumns = useMemo(
    () => [
      {
        Header: "RK '20",
        accessor: 'ranking2020',
        width: '10',
        sticky: 'left',
      },
      { Header: 'Universidad', accessor: 'universidad' },
      { Header: 'Índice ponderado', accessor: 'ponderado' },
      { Header: 'Ranking 2019', accessor: 'ranking2019' },
    ],
    [],
  )

  const academicosColumns = useMemo(
    () => [
      {
        Header: "RK '20",
        accessor: 'ranking2020',
        width: '10',
        sticky: 'left',
      },
      { Header: 'Universidad', accessor: 'universidad' },
      { Header: 'Índice ponderado', accessor: 'ponderado' },
      { Header: 'Ranking 2019', accessor: 'ranking2019' },
      { Header: '% JCE con doctorado', accessor: 'jcecondoctorado' },
      { Header: '% JCE con magister', accessor: 'jceconmagister' },
    ],
    [],
  )

  const alumnosColumns = useMemo(
    () => [
      {
        Header: "RK '20",
        accessor: 'ranking2020',
        width: '10',
        sticky: 'left',
      },
      { Header: 'Universidad', accessor: 'universidad' },
      { Header: 'Índice ponderado', accessor: 'ponderado' },
      { Header: 'Ranking 2019', accessor: 'ranking2019' },
      { Header: 'Promedio NEM 2020', accessor: 'promedionem2020' },
      { Header: 'Promedio PSU 2020', accessor: 'promediopsu2020' },
    ],
    [],
  )

  const investigacionColumns = useMemo(
    () => [
      {
        Header: "RK '20",
        accessor: 'ranking2020',
        width: '10',
        sticky: 'left',
      },
      { Header: 'Universidad', accessor: 'universidad' },
      { Header: 'Índice ponderado', accessor: 'ponderado' },
      { Header: 'Ranking 2019', accessor: 'ranking2019' },
      {
        Header: 'N° de publicaciones 2014-2018',
        accessor: 'numerodepublicaciones20142018',
      },
      {
        Header: 'Calidad  científica 2014-2018',
        accessor: 'calidadcientifica20142018',
      },
    ],
    [],
  )

  const ladata = useMemo(() => [...allData[slug]])

  return (
    <>
      <SEO />
      <div className="grid md:grid-cols-8 gap-4 mx-auto xl:container ">
        <div className="xl:col-span-6 lg:col-span-5 md:col-span-4 pt-4 pb-4 sm:pt-20">
          <RankingSelector
            activeRankingIndex={activeRanking}
            allRankings={allRankings}
            sectionslug={`rankings-generales`}
          />
          {slug === 'general' && <General ranking={ranking} />}
          {slug === 'tabladeposiciones' && (
            <GeneralTabla
              career={data}
              columns={tablaPosColumns}
              data={ladata}
            />
          )}
          {slug === 'calidad' && (
            <GeneralTabla
              career={data}
              columns={calidadColumns}
              data={ladata}
            />
          )}
          {slug === 'gestion' && (
            <GeneralTabla
              career={data}
              columns={gestionColumns}
              data={ladata}
            />
          )}
          {slug === 'academicos' && (
            <GeneralTabla
              career={data}
              columns={academicosColumns}
              data={ladata}
            />
          )}
          {slug === 'alumnos' && (
            <GeneralTabla
              career={data}
              columns={alumnosColumns}
              data={ladata}
            />
          )}
          {slug === 'investigacion' && (
            <GeneralTabla
              career={data}
              columns={investigacionColumns}
              data={ladata}
            />
          )}
        </div>
        <div className="xl:col-span-2 lg:col-span-3 md:col-span-4 sm:pt-20 pt-4 pb-4">
          <Sidebar
            activeRankingIndex={activeRanking}
            allRankings={allRankings}
            ranking={ranking}
            career={data}
            allData={allData}
            sectionslug="rankings-generales"
          />
        </div>
      </div>
    </>
  )
}

export default IndexPage
